import { Session } from 'next-auth';
import { useEffect, useState } from 'react';

import { faiService } from '@services/fai';

import { getServerSession } from '@actions/get-session';

import { SapicCategoryId } from '@app-types/api/sapic';
import { FaiType, FaiTypeWithEligibility } from '@app-types/plan';

import { HomeZones, eligibilityContextualisation, groupOffers } from '@helpers/eligibility';

interface UseEligibilityContextProps {
    defaultPlans: FaiType[];
}

export function useEligibilityContext({ defaultPlans }: UseEligibilityContextProps) {
    const [session, setSession] = useState<Session | null>(null);
    const [plans, setPlans] = useState<Record<string, FaiTypeWithEligibility>>(groupOffers(defaultPlans));
    const [idPanierCorbis, setIdPanierCorbis] = useState<string | undefined>();
    const [homeZone, setHomeZone] = useState<HomeZones | undefined>();

    useEffect(() => {
        const contextualisation = async () => {
            const session = await getServerSession();
            setSession(session);

            void eligibilityContextualisation(
                defaultPlans,
                async () =>
                    faiService.getOffers({
                        filterByTypes: [SapicCategoryId.FAI, SapicCategoryId.FAIM_UNLIMITED],
                        limit: -1,
                    }),
                (newPlans, idPanierCorbis, homeZone) => {
                    setPlans(groupOffers(newPlans));
                    setIdPanierCorbis(idPanierCorbis);
                    setHomeZone(homeZone);
                },
                session,
            );
        };
        void contextualisation();
    }, []);

    return {
        session,
        plans,
        idPanierCorbis,
        homeZone,
    };
}
